import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://waznk.sd.zain.com/ShekoAPIs/APIs/`
})

